import type { DataGridColumnSettings, DynamicFieldComponentProps } from '@myosh/odin-components';
import type { Observable } from 'rxjs';
import type { RecordResult } from '../@types/records';
import type { LinkedUser, UserRecordLinkEntity } from '../@types/users';

/**
 * Transforms the user record link columns into DataGridColumnSettings.
 * @param {Array<UserRecordLinkEntity>} recordLinkColumns - The items to transform into data grid columns.
 * @return {Array<DataGridColumnSettings>} The converted array of DataGridColumnSettings objects.
 */
export const transformUserRecordLinkColumns = (
  recordLinkColumns: Array<UserRecordLinkEntity>
): Array<DataGridColumnSettings> => {
  return recordLinkColumns.map((recordLinkColumn: UserRecordLinkEntity) => {
    return {
      ...recordLinkColumn, // enrich column data with record link entity configuration data
      title: recordLinkColumn.entityName,
      field: recordLinkColumn.entityPropertyName,
      entityId: recordLinkColumn.entityId,
      visible: true,
      type: 6,
      cellRenderer: 'USER_FIELD',
      isIdField: false,
      customDataProperties: { ...recordLinkColumn },
    };
  });
};

export function extractUserIds(value: Array<LinkedUser>) {
  return value.map((item) => item.value);
}

export const mapLinkedRecordIds = (linkedRecordIds?: Array<string | number>) => {
  return linkedRecordIds?.map((linkedRecordId) => {
    return Number(linkedRecordId);
  });
};

export interface UserRecordLinkProps extends DynamicFieldComponentProps<Array<LinkedUser>> {
  recordLinkFormat?: Array<UserRecordLinkEntity>;
  buttonCaption?: string;
  showSelectButton?: boolean;
  createExternalUsers?: boolean;
  saveRecord?: () => Observable<RecordResult>;
}
